import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";

export const createAppQueryClient = () => new QueryClient();

const sharedQueryClient = createAppQueryClient();

export const AppProviders = ({
  children,
  queryClient = sharedQueryClient,
}: {
  children: ReactNode;
  queryClient?: QueryClient;
}) => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      {children}
    </TooltipProvider>
  </QueryClientProvider>
);
